import React, {useContext, useEffect, useState} from "react";
import DragComponent from './DragComponent'
import {makeStyles} from "@material-ui/styles";
import {ItemSources} from "../ToolBarUtils/ItemSources";
import SearchField from "./SeachField";
import {uid} from "react-uid";
import DragGroup from "./DragGroup";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";

const useStyles = makeStyles(() => ({
    wrapper: {
        padding: 10
    },
    searchField: {
        margin: 10
    },
    dragComponents: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        margin: '0 10px',
        flexWrap: 'wrap',
        justifyContent: 'center'
    }
}));

const DragComponents = () => {
    const {userLanguage} = useSelector(state => state.app);
    const {screenTypeProps} = useContext(ScreenDesignerContextNew);
    const [sources, setSources] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [searchedValues, setSearchedValues] = useState([]);
    const classes = useStyles();

    function onChangeSearchField({target: {value = ''}}) {
        setSearchValue(value)
    }

    useEffect(() => {
        const getComponentsFromGroups = screenTypeProps.groups?.flatMap(group => {
            return group.components
        });
        setSources(getComponentsFromGroups)
    }, []);

    useEffect(() => {
        let filtered = sources.filter(e => multiLanguageValue(e.name, userLanguage).toLowerCase().includes(searchValue.toLowerCase()));
        setSearchedValues(filtered)
    }, [searchValue, userLanguage]);

    return (
        <div className={classes.wrapper}>
            <div className={classes.searchField}>
                <SearchField
                    onChange={onChangeSearchField}
                    searchValue={searchValue}
                />
            </div>
            {searchValue.length ? (
                <div className={classes.dragComponents}>
                    {searchedValues.map(component => {
                        const itemIndex = ItemSources.findIndex(i => i.type === component.id);
                        const item = ItemSources[itemIndex];
                        return (
                            <DragComponent
                                key={uid(item)}
                                source={item.source}
                                label={item.label}
                                icon={item.icon}
                                type={item.type}
                            />
                        )
                    })}
                </div>
            ) : (
                <div className={classes.dragGroupComponents}>
                    {screenTypeProps?.groups?.map(group => {
                        return(
                            <DragGroup
                                key={uid(group)}
                                group={group}
                            />
                        )
                    })}
                </div>
            )}
        </div>
    )
};

export default DragComponents